export default __webpack_public_path__ + "static/media/javascript-jeopardy.b3b6a5c6.png";